import {interpolate, pgettext} from "../../../utils/translate";

export function phcButtonClass(color, value) {
    const baseClass = 'phc-button'
    let classes = [baseClass]
    if (color) {
        classes.push(baseClass + '--' + color)
    }
    return classes
}

export function patientLabel(cardPrefix, cardNumber) {
    if (cardNumber) {
        return interpolate(
            pgettext('label', 'Patient: %(cardPrefix)s%(cardNumber)s'),
            {
                cardPrefix: cardPrefix ? cardPrefix : '',
                cardNumber: cardNumber,
            }
        )
    }
    return null
}

